import {DumpsterFire} from "../DumpsterFire";
import {DFGameConfig} from "../DFGameConfig";
import {gsap, Power1, TimelineLite} from "gsap";
import {DumpsterFireSound} from "../sound/DumpsterFireSound";

export class DFXIView extends PIXI.Container {
    constructor() {
        super();
        this.name = "DFXIView";
    }


    public playXIAnimation(reelId: number, rowId: number, toPosX: number, toPosY: number, duration: number): TimelineLite {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        const bird: PIXI.spine.Spine = new PIXI.spine.Spine(DumpsterFire.assetLoader.getSpineAsset("XIBird"));
        bird.position.set(114 * reelId + 80, 114 * rowId + 120);
        bird.visible = false;
        this.addChildAt(bird, 0);
        tl.add([() => {
            bird.visible = true;
            bird.state.setAnimation(0, "flyingLoop", true);
        }], 0);
        const angle: number = Math.atan2((toPosY * 114 + 118) - (114 * rowId + 120), ((toPosX * 114 + 76)) - ((114 * reelId + 80)));
        tl.add([() => {
            bird.rotation = angle + (-30);
        },
            gsap.fromTo(bird.position, {x: 114 * reelId + 100, y: 114 * rowId + 100}, {
                x: (toPosX * 114 + 76),
                y: (toPosY * 114 + 118),
                duration: duration
            })], 0);
        tl.add(() => {
            bird.state.setAnimation(0, "blastOff", false)
        }, `<${duration - 0.3}`);
        tl.add(() => {
            this.removeChild(bird);
        });
        return tl
    }

    public playInfectiousXWaysAnimation(reelId: number, rowId: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            anim: PIXI.spine.Spine = new PIXI.spine.Spine(DumpsterFire.assetLoader.getSpineAsset("XI"));
        anim.visible = true;
        anim.alpha = 0;
        anim.position.set(DFGameConfig.symbolWidth * reelId + 60, (DFGameConfig.symbolHeight * (rowId)) + 129)
        this.addChild(anim);
        tl.add([() => {
            DumpsterFire.soundPlayer.playSound(DumpsterFireSound.XI_WAYS_REVEAL);
            gsap.to(anim, {duration: 0.2, alpha: 1});
        },
            DumpsterFire.createTimelineForAnimation(anim, 0, "trigger", false)]);
        tl.add(() => {
            this.removeChild(anim);
        }, ">");
        return tl;
    }
}